import styled from '@emotion/styled';
import { Checkbox } from '@material-ui/core';
import React, { useRef } from 'react';

import { useHover } from '../../../../../hooks/useHover';
import { useId } from '../../../../../hooks/useId';
import { FlexContainer } from '../../../../../layout/Flex';
import { MUI_CHECKBOX_SIZE } from '../../../../../themes/muiTheme';

const ListItemContainer = styled('label')<{ selected?: boolean }>((p) => ({
  padding: p.theme.spacing(1.5),
  margin: `0 -${p.theme.spacing(1.5)}px`,
  borderRadius: p.theme.custom.border.radius(),
  backgroundColor: p.selected
    ? p.theme.custom.colors.blue.w100
    : p.theme.custom.colors.gray.white,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: p.selected
      ? p.theme.custom.colors.blue.w200
      : 'rgba(237, 245, 253, .5)'
  }
}));

const ListItemContent = styled('div')((p) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: p.theme.spacing()
}));

// export const ListItemTitle = styled('div')((p) => ({
//   display: 'flex',
//   gap: p.theme.spacing()
// }));

const Header = styled('div')((p) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: p.theme.spacing()
}));

const HeaderTitleContainer = styled('div')((p) => ({
  display: 'flex',
  alignItems: 'center',
  lineHeight: `${p.theme.spacing(3)}px`
}));

const HeaderTitle = styled('div')((p) => ({
  display: 'flex',
  alignItems: 'center',
  gap: p.theme.spacing()
}));

const SubHeader = styled('div')((p) => ({
  display: 'flex',
  alignItems: 'center',
  gap: p.theme.spacing()
}));

const CheckboxAnimationContainer = styled('div')<{
  visible?: boolean;
}>((p) => ({
  transition: 'all .2s ease-in',
  width: p.visible ? MUI_CHECKBOX_SIZE + p.theme.spacing() : 0,
  opacity: p.visible ? 1 : 0
}));

export const SelectableListItem: React.FC<{
  selected?: boolean;
  onSelect?: (nextSelected: boolean) => void;
  header: React.ReactNode;
  headerActions?: React.ReactNode;
  subHeader?: React.ReactNode;
  isSelectable?: boolean;
  containerStyle?: React.CSSProperties;
}> = ({
  selected,
  onSelect,
  header,
  headerActions,
  subHeader,
  isSelectable = true,
  containerStyle,
  children
}) => {
  const id = useId();
  const ref = useRef<HTMLLabelElement>(null);
  const hovered = useHover(ref);
  return (
    <ListItemContainer htmlFor={id} selected={selected} ref={ref} style={containerStyle}>
      <ListItemContent>
        <Header>
          <HeaderTitleContainer>
            <CheckboxAnimationContainer
              visible={isSelectable && (hovered || selected)}
            >
              <Checkbox
                id={id}
                checked={!!selected}
                onChange={(ev) => onSelect && onSelect(ev.target.checked)}
              />
            </CheckboxAnimationContainer>
            <HeaderTitle>{header}</HeaderTitle>
          </HeaderTitleContainer>
          {headerActions && <FlexContainer>{headerActions}</FlexContainer>}
        </Header>
        {subHeader && <SubHeader>{subHeader}</SubHeader>}
        {children}
      </ListItemContent>
    </ListItemContainer>
  );
};
